<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_END_PRODUCT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.adminContext.endProduct;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(end_product) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_END_PRODUCT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(end_product, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateEndProduct.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_END_PRODUCT_QUERY = gql `
  query ($id: ID!) { 
    adminContext {
      endProduct (id: $id) {
        id
        description
        barcode        
        brandId
        brand {
          id
          name
        }
        groupId
        group{
          id
          name
        }
        unitId
        unit {
          id
          name
        }
        varietyId
        variety{
          id
          name
        }
        validations
      }
    }
    globalContext {
      allUnits {
        id
        name
      }
      allVarieties {
        id
        name
        title
      }
    } 
    accountGlobalSharedContext {
      allBrandsOfItems {
        id
        name
      }
      allGroups{
        id
        name
      }
    }
  }
`;

const UPDATE_END_PRODUCT_MUTATION = gql `
  mutation($input: EndProductUpdateInputObject!) {
    updateEndProduct(input: $input) {
      item {
        id        
        description
        barcode        
        unitId
        unit {
          name
        }        
      }
      errors
    }
  }
`;

</script>

<style scoped></style>